<template>
	<script type="text/x-template" id="template-contrast" class="template">
		<li class="block edit_block contrast-block adjustment-block">
			<div class="header-container edit_block_header drag_handle">
				<label class="lookup_block_name name">Contrast</label>
			</div>

			<div class="block_options">
				<div class="block-sliders-container">
					<span class="slider-name">Contrast</span>
					<input
						type="range"
						min="-100"
						max="100"
						value="0"
						step="1"
						data-pass-index="0"
						class="range_slider contrast_slider adjustmentBlock-slider"
					/>
					<div class="input-group --with-knob">
						<input type="text" class="input-knob" />
						<input type="number" class="range_value contrast_range adjustmentBlock-range" value="0" name="quantity" min="-100" max="100" step="0.1" />
					</div>
				</div>
			</div>
		</li>
	</script>
</template>

<script>
export default {};
</script>

<style></style>
